<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="rule02" :title="$t('store.dialogRule_title')"/>
    <div class="rule container">
      <h1 class="title lkrule"><span>{{ $t("store.dialogRule_title") }}</span></h1>
      <section
        class="rule-cont"
        v-for="(item, index) in Rule02"
        :key="index"
      >
        <div v-html="item.description"></div>
      </section>
    </div>
  </div>
</template>
<script>
  import { getJsonFile } from '@/utils/jsonFile';
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    components: { pageHead },
    computed: {
      Rule02() {
        return getJsonFile(process.env.DEF_webStyle, 'rule02');
      },
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        return this.$t("store.dialogRule_title") + (this.HasX ? ' - ' + process.env.WEB_TITLE : '');
      }
    }
  };
</script>
